import { AxiosResponse } from 'axios';
import _ from 'lodash';
import Logger from '../logger';
import { API_V1 } from './APIs/APIv1';

export interface AgencyAdminUser {
  id: string;
  email: string;
  firstname?: string;
  lastname?: string;
  tenantId?: string;
  tenantName?: string;
}

export interface AgencyAdminsResponse {
  users: AgencyAdminUser[];
}

export const getAgencyAdmins = async (): Promise<AxiosResponse<any, any>['data']> => {
  try {
    const response = await API_V1.get('/agency-management/agency-admins');
    return { data: response.data };
  } catch (e) {
    Logger.trace('Error while getting agency admins');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e) };
  }
};

export const bindAccountToAgency = async (accountTenantId: string, agencyTenantId: string) => {
  try {
    const response = await API_V1.post('/agency-management/bind', { accountTenantId, agencyTenantId });
    return response.data;
  } catch (e) {
    Logger.trace('Error while binding account to agency');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e) };
  }
};

export const unbindAccountFromAgency = async (accountTenantId: string) => {
  try {
    const response = await API_V1.post('/agency-management/unbind', { accountTenantId });
    return response.data;
  } catch (e) {
    Logger.trace('Error while unbinding account from agency');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e) };
  }
};
